<script setup lang="ts">
defineProps<{
    title: string;
    price?: string;
    description: string;
    learnMoreHref: string;
}>();
</script>

<template>
    <div class="flex w-full flex-col rounded-lg bg-white px-6 pb-6 pt-11 shadow-[0px_4px_19px_0px_rgba(0,0,0,0.1)]">
        <div class="flex flex-col gap-4 text-primary">
            <div class="flex items-start justify-between gap-4 text-[22px] font-medium leading-6">
                <span>{{ title }}</span>
                <span v-if="price" class="shrink-0 text-right">{{ price }}</span>
            </div>

            <p class="text-lg leading-6">{{ description }}</p>

            <a :href="learnMoreHref" class="text-lg leading-6 underline">
                Learn more
            </a>
        </div>
    </div>
</template>
